import React from "react";

export const GraphOutlineSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 25 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.6 6L18.1 5L17.6 5.5L14.1 9L12.6 7.5L11.1 6L5.59998 11.5L5.60004 11.5001V17V19H7.60004H17.6H19.6L19.6 17V6.5V6ZM7.60004 12.5L7.60004 17H17.6V8.49998L15.6 10.5L15.6 10.5L14.1 12L14.1 12L12.6 10.5L11.1 9L7.60004 12.5Z"
      ></path>
    </svg>
  );
};
